<template>
  <v-container>
    <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard>
          <FixedCostAreaDetails
            v-if="fixedCost != null"
            @submitted="submitted"
            :loading="loading"
            :fixedCostAreaSummary="fixedCost"
            :editMode="true"
          >Fixed Cost #{{$route.params.id}}</FixedCostAreaDetails>
        </SimpleCard>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard v-if="fixedCost != null">
          <FixedCostDetails
            :rideTypes="rideTypes"
            :fixedCost="fixedCost.fixed_cost"
            name="Global Fixed Cost"
          >Fixed Cost #{{$route.params.id}}</FixedCostDetails>
        </SimpleCard>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard v-if="fixedCost != null">
          <FixedCostCustomerList :rideTypes="rideTypes" :fixedCostArea="fixedCost"></FixedCostCustomerList>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import FixedCostAreaDetails from "@/components/settings/pricing/FixedCostAreaDetails.vue";
import FixedCostDetails from "@/components/settings/pricing/FixedCostDetails.vue";
import FixedCostCustomerList from "@/components/settings/pricing/FixedCostCustomerList.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    FixedCostAreaDetails,
    FixedCostDetails,
    FixedCostCustomerList,
    SimpleCard
  },
  data: function() {
    return {
      fixedCost: null,
      loading: false,
      rideTypes: null
    };
  },
  mounted: async function() {
    try {
      var url = `${this.$store.state.apiUrl}/fixed_cost/${
        this.$route.params.id
      }`;

      let response = await axios.get(url, {
        params: {}
      });

      var fixedCost = response.data;

      if (fixedCost.fixed_cost == null) {
        fixedCost.fixed_cost = {};
      }

      if (fixedCost.fixed_cost.fixed_cost_ride_type == null) {
        fixedCost.fixed_cost.fixed_cost_ride_type = [];
      }

      this.fixedCost = response.data;
    } catch (error) {
      this.loading = false;
      console.log("Failed to get fixed costs");
    }

    try {
      var url = `${this.$store.state.apiUrl}/ride_types/all`;

      let response = await axios.get(url, {
        params: {}
      });

      this.rideTypes = response.data;

      console.log("got ride types");
    } catch (error) {
      this.loading = false;
      console.log("Failed to get ride types " + error);
    }
  },
  methods: {
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    },
    submitted: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/fixed_cost/${
        this.$route.params.id
      }`;

      var failed = this.failed;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    }
  }
};
</script>
